<template>
	<v-container fluid >
		<v-toolbar elevation="1">
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>

			<template v-slot:extension>
				<v-tabs v-model="tab" centered>
					<v-tabs-slider color="yellow"></v-tabs-slider>
					<v-tab v-for="item in tabs" :key="item">
						{{ item }}
					</v-tab>
				</v-tabs>
			</template>

			<!-- <v-btn icon @click="search.item2.visible = !search.item2.visible">
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
			<v-btn icon>
				<v-icon>mdi-plus</v-icon>
			</v-btn> -->
		</v-toolbar>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<v-row class="mt-2">
					<v-col cols="12" md="3">
						<v-card :loading="loading.level1" class="d-flex flex-column" max-height="80vh">
							<v-toolbar flat>
								<v-toolbar-title>Класи</v-toolbar-title>
								<v-spacer></v-spacer>
								<!-- <v-btn icon>
									<v-icon>mdi-plus</v-icon>
								</v-btn> -->
							</v-toolbar>
							<v-card-text class="flex-grow-1 overflow-y-auto">
								<v-list>
									<v-list-item v-for="(item, index) in items1" :key="index" @click="onLevel1(item)">
										<v-list-item-avatar class="text-center" color="primary" size="48">
											 <v-avatar color="primary" size="48">
												<span class="white--text text-h5">{{ item.code }}</span>
											</v-avatar>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title class="text-wrap" v-text="item.name"></v-list-item-title>
											<!-- <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle> -->
										</v-list-item-content>

										<!-- <v-list-item-action>
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													
												</v-list>
											</v-menu>
										</v-list-item-action> -->
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="3">
						<v-card :loading="loading.level2" class="d-flex flex-column" max-height="80vh">
							<v-toolbar flat :extended="search.level2.visible">
								<v-toolbar-title>Рівень 2</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="search.level2.visible = !search.level2.visible">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
								<!-- <v-btn icon>
									<v-icon>mdi-plus</v-icon>
								</v-btn> -->

								<template v-slot:extension v-if="search.level2.visible">
									<v-text-field v-model="search.level2.text"
										hide-details
										single-line
										clearable
									></v-text-field>
								</template>
							</v-toolbar>
							<v-card-text class="flex-grow-1 overflow-y-auto">
								<v-list>
									<v-list-item v-for="(item, index) in items2" :key="index" @click="onLevel2(item)">
										<v-list-item-content>
											<v-list-item-title class="text-wrap" v-text="item.name"></v-list-item-title>
											<v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item>
														<!-- <v-list-item-title>Нове авто</v-list-item-title>
														<v-list-item-action>
															<v-checkbox v-item3="item.isNew" @change="onBrandIsNew(item)"></v-checkbox>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</v-menu>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" md="2">
						<v-card :loading="loading.level3" class="d-flex flex-column" max-height="80vh">
							<v-toolbar flat :extended="search.level3.visible">
								<v-toolbar-title>Рівень 3</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="search.level3.visible = !search.level3.visible">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
								<!-- <v-btn icon>
									<v-icon>mdi-plus</v-icon>
								</v-btn> -->

								<template v-slot:extension v-if="search.level3.visible">
									<v-text-field v-model="search.level3.text"
										hide-details
										single-line
										clearable
									></v-text-field>
								</template>
							</v-toolbar>
							<v-card-text class="flex-grow-1 overflow-y-auto">
								<v-list>
									<v-list-item v-for="(item, index) in items3" :key="index" @click="onLevel3(item)">
										<v-list-item-content>
											<v-list-item-title class="text-wrap" v-text="item.name"></v-list-item-title>
											<v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item>
														<!-- <v-list-item-title>Нове авто</v-list-item-title>
														<v-list-item-action>
															<v-checkbox v-item3="item.isNew" @change="onBrandIsNew(item)"></v-checkbox>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</v-menu>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" md="2">
						<v-card :loading="loading.level4" class="d-flex flex-column" max-height="80vh">
							<v-toolbar flat :extended="search.level4.visible">
								<v-toolbar-title>Рівень 4</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="search.level4.visible = !search.level4.visible">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
								<!-- <v-btn icon>
									<v-icon>mdi-plus</v-icon>
								</v-btn> -->

								<template v-slot:extension v-if="search.level4.visible">
									<v-text-field v-model="search.level4.text"
										hide-details
										single-line
										clearable
									></v-text-field>
								</template>
							</v-toolbar>
							<v-card-text class="flex-grow-1 overflow-y-auto">
								<v-list>
									<v-list-item v-for="(item, index) in items4" :key="index" @click="onLevel4(item)">
										<v-list-item-content>
											<v-list-item-title class="text-wrap" v-text="item.name"></v-list-item-title>
											<v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item>
														<!-- <v-list-item-title>Нове авто</v-list-item-title>
														<v-list-item-action>
															<v-checkbox v-item3="item.isNew" @change="onBrandIsNew(item)"></v-checkbox>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</v-menu>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" md="2">
						<v-card :loading="loading.level5" class="d-flex flex-column" max-height="80vh">
							<v-toolbar flat :extended="search.level5.visible">
								<v-toolbar-title>Рівень 5</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="search.level5.visible = !search.level5.visible">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
								<!-- <v-btn icon>
									<v-icon>mdi-plus</v-icon>
								</v-btn> -->

								<template v-slot:extension v-if="search.level5.visible">
									<v-text-field v-model="search.level5.text"
										hide-details
										single-line
										clearable
									></v-text-field>
								</template>
							</v-toolbar>
							<v-card-text class="flex-grow-1 overflow-y-auto">
								<v-list>
									<v-list-item v-for="(item, index) in items5" :key="index" @click="onLevel5(item)">
										<v-list-item-content>
											<v-list-item-title class="text-wrap" v-text="item.name"></v-list-item-title>
											<v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item>
														<!-- <v-list-item-title>Нове авто</v-list-item-title>
														<v-list-item-action>
															<v-checkbox v-item3="item.isNew" @change="onBrandIsNew(item)"></v-checkbox>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</v-menu>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item>
				<v-card flat>
					<v-card-title>
						<!-- Nutrition -->
						<v-spacer></v-spacer>
						<v-text-field
							v-model="search.table.text"
							append-icon="mdi-magnify"
							label="Search"
							single-line
							hide-details
							@click:append="onSearch"
							@keyup.enter="onSearch"
						></v-text-field>
					</v-card-title>
					<v-data-table
						:headers="headers"
						:items="items"
						:loading="loading.table"
						loading-text="Loading... Please wait"
					></v-data-table>
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'DrugATC',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail, zDialogEstimate,
		zConfirmDelete,
	},
	data: () => ({
		title: 'АТС Класифікація',
		//subtitle: 'Anatomical Therapeutic Chemical (АТС) classification system',
		subtitle: 'Міжнародний стандарт методології для проведення статистичних досліджень у сфері споживання лікарських засобів',
		icon: 'mdi-molecule',
		color: 'red darken-1',
		//loading: false,

		tabs: ['рівні','таблиця'],
		tab: null,

		search: {
			level1: {
				visible: false,
				text: '',
			},
			level2: {
				visible: false,
				text: '',
			},
			level3: {
				visible: false,
				text: '',
			},
			level4: {
				visible: false,
				text: '',
			},
			level5: {
				visible: false,
				text: '',
			},
			table: {
				visible: false,
				text: '',
			},
		},

		loading: {
			level1: false,
			level2: false,
			level3: false,
			level4: false,
			level5: false,
			table: false,
		},

		/* item1: {},
		item2: {},
		item3: {},
		item4: {},
		item5: {}, */

		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Назва англійською', value: 'nameEn', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true},
			{ text: 'Рівень', value: 'level', sortable: true},
			{ text: '', value: 'actions', sortable: false },
		],

		items: [],
		items1: [],
		items2: [],
		items3: [],
		items4: [],
		items5: [],
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),
	},

	created () {
		this.loadLevel1()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		//--------------------------------------------------------------------
		onLevel1(item) {
			this.loadLevel2(item);
		},

		loadLevel1() {
			let that = this
			this.loading.level1 = true
			axios.get('/drug/atc', { params: { level: 1 }}).then(response => {
				//console.log(that.$options.name, 'loadLevel1','response.data', response.data)
				that.items1 = response.data
				that.items2 = []
				that.items3 = []
				that.items4 = []
				that.items5 = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.level1 = false));
		},

		//--------------------------------------------------------------------

		onLevel2(item) {
			//console.log(this.$options.name, 'onLevel2','item', item)
			this.loadLevel3(item);
		},

		loadLevel2(item) {
			//console.log(this.$options.name, 'loadLevel2','item1', item1)

			let that = this
			this.loading.level2 = true
			axios.get('/drug/atc', { params: { parent_id: item.id }}).then(response => {
				//console.log(that.$options.name, 'loadLevel2','response.data', response.data)
				that.items2 = response.data
				that.items3 = []
				that.items4 = []
				that.items5 = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.level2 = false));
		},

		//--------------------------------------------------------------------

		onLevel3(item) {
			//console.log(this.$options.name, 'onLevel3','item', item)
			this.loadLevel4(item);
		},

		loadLevel3(item) {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			let that = this
			this.loading.level3 = true
			axios.get('/drug/atc', { params: { parent_id: item.id }}).then(response => {
				//console.log(that.$options.name, 'loadLevel3','response.data', response.data)
				that.items3 = response.data
				that.items4 = []
				that.items5 = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.level3 = false));
		},

		//--------------------------------------------------------------------

		onLevel4(item) {
			//console.log(this.$options.name, 'onLevel4','item', item)
			this.loadLevel5(item);
		},

		loadLevel4(item) {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			let that = this
			this.loading.level4 = true
			axios.get('/drug/atc', { params: { parent_id: item.id }}).then(response => {
				//console.log(that.$options.name, 'loadLevel4','response.data', response.data)
				that.items4 = response.data
				that.items5 = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.level4 = false));
		},

		//--------------------------------------------------------------------

		onLevel5(item) {
			//console.log(this.$options.name, 'onLevel4','item', item)
		},

		loadLevel5(item) {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			let that = this
			this.loading.level5 = true
			axios.get('/drug/atc', { params: { parent_id: item.id }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items5 = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.level5 = false));
		},

		//--------------------------------------------------------------------

		onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)
			let that = this
			this.loading.table = true
			axios.get('/drug/atc', { params: { search: this.search.table.text }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.table = false));
		},
	},
}
</script>